import { render, staticRenderFns } from "./modalSignUp.vue?vue&type=template&id=1854218d&scoped=true&lang=pug&"
import script from "./modalSignUp.vue?vue&type=script&lang=js&"
export * from "./modalSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854218d",
  null
  
)

export default component.exports